import { CommonSelect, Input } from 'common/InputForm'
import { CustomModal } from 'components/modals/ModalBox'
import useButtonLoader from 'hooks/useButtonLoader'
import React, { useEffect, useState } from 'react'
import { addSubSubCategoryApi, subCategoryListApi, updateSubSubCategoryApi } from 'services/subCategory'
import { toastMessage } from 'utils/toastMessage'

const UpdateSubSubCategory = ({ show, close, data, listing = () => { } }) => {
    const [input, setInput] = useState({ name: '', subcategory: '' })
    const [error, setError] = useState({})
    const isUpdated = data?.type === 'Update'
    const [buttonLoader, setButtonLoader] = useButtonLoader(isUpdated ? 'Update' : 'Add');
    const [subCategory, setSubCategory] = useState([])

    // console.log({ subCategory, isUpdated, input, data })
    // ---------validation-----------
    const validation = () => {
        let status = true;
        let errorMessage = {};

        if (!input?.name) {
            errorMessage["name"] = "Please enter Name";
            status = false;
        }
        if (!input?.subcategory) {
            errorMessage["subcategory"] = "Please select Sub category";
            status = false;
        }

        setError(errorMessage);

        return status;
    };
    // -------modal-close------------
    const handleClose = () => {
        close()
        setError({})
        setInput({ name: '', subcategory: '' });
    }
    // -----------handle-onchange----------------
    const handleChange = (e) => {
        const { name, value } = e.target;
        const noLeadSpace = value.replace(/^\s+/, '');
        setInput({ ...input, [name]: noLeadSpace });
    };

    // --------sub-category-list-----------------
    useEffect(() => {
        const fetchSubSubCategory = async () => {
            try {
                const res = await subCategoryListApi({limit:10000});
                if (res?.data?.code === 200) {
                    setSubCategory(res?.data?.data?.data || []);
                }
            } catch (error) {
                console.log("Cat Data fetch error:---> ", error);
            }
        };
        fetchSubSubCategory()
    }, [])

    // -------------Add-and--update-offer---------------------
    const handleSubmit = async (e) => {
        if (validation()) {
            try {
                setButtonLoader(true);
                const payload = { ...input };
                const res = isUpdated
                    ? await updateSubSubCategoryApi(data?._id, payload)
                    : await addSubSubCategoryApi(payload);
                const { code, message } = res?.data;
                if (code === 200) {
                    handleClose()
                    toastMessage(message, 'success', 'updateSUbSubCategory')
                    listing()
                }
            } catch (error) {
                console.error("Upload Error:", error);
            } finally {
                setButtonLoader(false);
            }
        }
    };

    useEffect(() => {
        if (isUpdated && show) {
            const subcategoryId = typeof data?.subcategory === 'object'
                ? data?.subcategory?._id
                : data?.subcategory;

            setInput({
                name: data?.name || '',
                subcategory: subcategoryId || ''
            })
        }
    }, [data, isUpdated, show])

    const subCategoryOptions = subCategory.map((item) => ({
        value: item?._id,
        label: item?.name,
    }));
    const selectedSubCategoryOption =
        subCategoryOptions.find((item) => item.value === input?.subcategory)
        || (data?.subcategory?._id === input?.subcategory
            ? { value: data?.subcategory?._id, label: data?.subcategory?.name }
            : null);

    return (
        <CustomModal
            className={"add_model"}
            show={show}
            handleClose={handleClose}
        >
            <h3>{data?.type} Filter Category</h3>
            <div className="form_field">
                <Input
                    className={"form-control input"}
                    label='Name'
                    type={"text"}
                    name='name'
                    value={input.name || ""}
                    onChange={handleChange}
                    placeholder="Enter name"
                    error={error?.name}
                />
            </div>
            <div className="form_field">
                <CommonSelect
                    label="Sub Category"
                    value={selectedSubCategoryOption}
                    onChange={(selectedOption) => {
                        setInput((prev) => ({
                            ...prev,
                            subcategory: selectedOption?.value || '',
                        }));
                    }}
                    options={subCategoryOptions}
                    placeholder="Search Sub Category..."
                    isSearchable={true}
                    error={error.subcategory}
                    noOptionsMessage={() => "No sub category found"}
                />
            </div>
            <div className="button_wrap">
                <button
                    type="button"
                    className="button light"
                    onClick={handleClose}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    ref={buttonLoader}
                    onClick={handleSubmit}
                    className="button"
                >
                    {isUpdated ? 'Update' : 'Add'}
                </button>
            </div>
        </CustomModal>
    )
}

export default UpdateSubSubCategory
